import { useSelector } from "react-redux";
import { getCapabilities } from "utils/mapStateToProps";
import { useRouter } from "next/router";
import { authedRoutes, unauthedRoutes } from "components/Nav/routes";
import { useViewport } from "utils/context";
import { useAppHubRoute } from "./hub";
import { useIsAuthed } from "utils/selectors";
import { useInBeta } from ".";

export const useRouteConfig = () => {
  const isAuthed = useIsAuthed();
  const inBeta = useInBeta();
  const capabilities = useSelector((state) => getCapabilities(state));
  const { route } = useRouter();
  const { isDesktop } = useViewport();
  const appRoot = useAppHubRoute();
  const input = { capabilities, route, isDesktop, appRoot, inBeta };

  return isAuthed ? authedRoutes(input) : unauthedRoutes(input);
};
